import { MutableRefObject } from 'react';
import { generateUniqueId } from './commonUtils';

export class ImageStore {
   private static instance: ImageStore;
   private store: Map<string, any>;

   private constructor() {
      this.store = new Map();
   }

   public static getInstance(): ImageStore {
      if (!ImageStore.instance) {
         ImageStore.instance = new ImageStore();
      }
      return ImageStore.instance;
   }

   public setItem(key: string, value: any): void {
      this.store.set(key, value);
   }

   public getItem(key: string): any {
      return this.store.get(key);
   }

   public removeItem(key: string): void {
      this.store.delete(key);
   }
}

export const closeImageModalRevamp = (
   { args, onUserAction, additionalData, getState }: any,
   callback: Function
) => {
   const isCloseWithoutUpload = args?.[0] === 'closeWithoutUpload';
   const { storeValues } = getState();
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
   let isSuccess;

   // if (isNewSKYCJourney) {
      isSuccess = additionalData?.dataFromWidget?.response?.status === '200';
   // } else {
   //    isSuccess = additionalData?.dataFromWidget?.response?.status?.code === '200';
   // }

   isSuccess = isSuccess || isCloseWithoutUpload;

   if (isSuccess) {
      console.log("additionalData?.dataFromWidget?.response?.status closeImageModalRevamp>>>",additionalData?.dataFromWidget?.response?.status)
      console.log("ragini img success>>>")
      callback();
      if (!isCloseWithoutUpload) {

            onUserAction({
               actions: [
                  {
                     type: 'callUtilFunction',
                     payload: {
                        utilName: 'openVideoModal',
                        args: [{}],
                     },
                  },
               ],
            });
         
      }
   } else {
      onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  title: 'Something went wrong please try again',
                  dismissDuration: 5000,
                  position: 'bottom-center',
                  state: 'error',
                  style: {
                     zIndex: 10000,
                  },
               },
            },
         ],
      });
   }
};

export const handleFaceMatchResponseRevamp = (
   props: any,
   faceMatchFailureCallback: (faceAuthMessage: string) => void
) => {
   const { onUserAction, additionalData, getState } = props;
   const response = additionalData?.dataFromWidget?.response;
   const { storeValues } = getState();
   const DEFAULT_FACE_AUTH_MESSAGE ='To complete verification, it is important that this photo & your Aadhaar photo matches.';
   const imageStore = ImageStore.getInstance();
   const waterMarkUserImage = imageStore.getItem('waterMarkUserImage');
   const actions = [];

   let isSuccess;
   let isFaceMatched;
   let isFaceMatchFailureStatus;
   let faceAuthMessage;

   let headers = {};

       isSuccess = response?.status === '200'; //TODO remove mock
      // isSuccess =  true;
      isFaceMatched = true;
      const failedAuthCheck: any =
         response?.data?.imageValidationResult &&
         Object.keys(response?.data?.imageValidationResult).length > 0 &&
         Object.values(response?.data?.imageValidationResult).find(
            (result: any) => result?.result?.toLowerCase() === 'failed'
         );
      isFaceMatchFailureStatus = !!failedAuthCheck;
      faceAuthMessage = failedAuthCheck?.displayMessage;

   faceAuthMessage = faceAuthMessage || DEFAULT_FACE_AUTH_MESSAGE;
   const blockUser = !isFaceMatched || isFaceMatchFailureStatus;

   if (!isSuccess) {

      actions.push(
         {
            type: 'fullPageLoader',
            payload: {
               show: false,
            },
         },
         {
            type: 'showToast',
            payload: {
               title: 'Something went wrong please try again',
               dismissDuration: 5000,
               position: 'bottom-center',
               state: 'error',
               style: {
                  zIndex: 10000,
               },
            },
         }
      );
   } else {
      if (blockUser) {
         actions.push({
            type: 'fullPageLoader',
            payload: {
               show: false,
            },
         });
         faceMatchFailureCallback(faceAuthMessage);
         // if (isNewSKYCJourney) {
            actions?.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step4Widget',
                  eventAction: 'impression',
                  eventLabel: 'retry',
                  eventValue: 'photo does not match with your aadhar',
                  customValue: faceAuthMessage,
                  customLabel: 'card',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            });
         // } 
      } else {
            console.log("additionalData?.dataFromWidget?.response handleFaceMatchResponseRevamp",additionalData?.dataFromWidget?.response)
         let apiUrl = 'skyc/ecaf-commons/api/v2/image/upload/image/v1';

        
            apiUrl = 'new-acq/dochub/doc-hub/upload/image';
            const circleId = storeValues?.appData?.address?.circleId;
            const consumerLob = storeValues?.appData?.lob;
            headers = {
               source: 'shop',
               'x-correlation-id': generateUniqueId(),
               'x-consumer-lob': consumerLob,
               circleId
            };
  

         actions.push({
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl,
               authTokenGroup: 'SKYC_REVERIFICATION',
               ...{ headers },
               body: waterMarkUserImage,
               onSuccess: {
                  actions: [
                     {
                        type: 'fullPageLoader',
                        payload: {
                           show: false,
                        },
                     },
                    
                     {
                        payload: {
                           args: ['success'],
                           utilName: 'closeImageModalRevamp',
                        },
                        type: 'callUtilFunction',
                     },
                  ],
               },
               onError: {
                  actions: [
                     {
                        type: 'fullPageLoader',
                        payload: {
                           show: false,
                        },
                     },
                     {
                        type: 'showToast',
                        payload: {
                           title: 'something went wrong please try again',
                           dismissDuration: 5000,
                           position: 'bottom-center',
                           state: 'error',
                           style: {
                              zIndex: 10000,
                           },
                        },
                     },
                  ],
               },
            },
         });
      }
   }
   onUserAction({
      actions,
   });
};

export const closeCameraModalWithErrorAction = (
   type: 'image' | 'video',
   artistRef?: MutableRefObject<any>
) => {
   const utilName = type === 'image' ? 'closeImageModalRevamp' : 'closeVideoModalRevamp';
   artistRef?.current?.onUserAction({
      id: 'closeVideoModalAction',
      actions: [
         {
            payload: {
               args: ['closeWithoutUpload'],
               utilName,
            },
            type: 'callUtilFunction',
         },
         {
            type: 'showToast',
            payload: {
               title: 'Allow camera permission \n This is required to take your photo and video for KYC.',
               description: 'Allow camera access from your phone settings to proceed.',
               dismissDuration: 5000,
               position: 'top-center',
               state: 'error',
               style: {
                  zIndex: 10000,
               },
            },
         },
      ],
   });
};
